import { api, queryParams, getEncodedLocationOriginQueryParam } from '@ezugi/utils';

import { API_PREFIX } from '../../../util/apiPrefix';
import {
  AuthenticationParams,
  Game,
  GameTypeValue,
  InitialConfig,
  Locale,
} from './InitialDataResult';

const VITE_API_URL = import.meta.env.VITE_API_URL ?? '';
const VITE_API_LOAD_TABLE_CONFIG = import.meta.env.VITE_API_LOAD_TABLE_CONFIG
  ?? '/server/services/loadTableConfig.php';
const URL = `${VITE_API_URL}${API_PREFIX}${VITE_API_LOAD_TABLE_CONFIG}`;

export type LoadTableConfigResponse = {
  result: {
    authenticationParams: AuthenticationParams;
    definitions: Record<string, string>;
    errorCode: number;
    game: Game;
    gameTypes: Record<number, GameTypeValue>;
    initialAuthenticationTarget: string;
    config: InitialConfig;
    language: string;
    locale: Locale;
    skin: string;
    outgoing: {
      dataDogEnabled: boolean;
      outgoingCalls: boolean;
      sentrySettings: any;
    },
    tables?: Record<string, Record<string, unknown>>,
    exclude_tables?: string[];
    exclude_games?: string[];
    favorite?: string[];
    userData: {
      balance: number;
      client_id: string;
      client_ip: string;
      currency: string;
      current_player_token: string;
      nickname: string;
      operator_id: number;
      session_id: number;
      uid: string;
      vip: number;
    };
    agora?: Record<string, any>;
  };
};

type FetchTableConfigArgs = {
  localeGroups?: string[];
  configGroups?: string[];
};

export const fetchTableConfig = ({ localeGroups }: FetchTableConfigArgs) => {
  const withLocaleGroups = localeGroups?.length
    ? `&localeGroups=${localeGroups?.join(',')}`
    : '';
  const locationOrigin = getEncodedLocationOriginQueryParam('base64');

  return api.get<LoadTableConfigResponse>(
    `${URL}${queryParams.stringify()}${withLocaleGroups}${locationOrigin}`
  );
};
